<template>
    <section v-if="isLoaded" class="quiz-finish-page">
        <div class="quiz-finish-container" v-if="hideAnswers">
          <h1 v-if="quiz.confirmation_message" class="text-center empty-title">
            {{quiz.confirmation_message}}
          </h1>
          <h1 v-else class="text-center empty-title">
            {{ trans('Form successfully submitted') }}
          </h1>
        </div>
        <FormReport :id="this.id" v-else-if="quiz"></FormReport>
    </section>
</template>

<script>
import {mapMutations} from "vuex";
import FormReport from "./FormReport.vue";

export default {
    name: "Confirm",
    components: {FormReport},
    methods: {
        ...mapMutations(['fetchQuizReport', 'changeIsLoaded']),
    },

  computed: {
    id() {
      return this.$route.params.id;
    },

    hideAnswers() {
      return this.$store.state.hide_answers;
    },

    isLoaded() {
      if (this.$store.state?.isLoaded) {
        return this.$store.state?.isLoaded;
      }

      return false;
    },

    quiz() {
      return this.$store.state.activeQuiz;
    },
  },

  beforeMount() {
    this.fetchQuizReport(this.id);
  },

  beforeDestroy() {
      this.changeIsLoaded();
  }
}
</script>
